import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { Observable } from 'rxjs';
export interface CheckPersonResponse {
  status: string;
  data: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  constructor(private readonly httpservice: HttpService) {}

  checkDuplicate(request: any): Observable<any> {
    return this.httpservice.post('/registration/check-person', request);
  }
  checkEmail(request: any): Observable<any> {
    return this.httpservice.post('/registration/checkEmail', request);
  }

  checkSSN(request: any): Observable<any> {
    return this.httpservice.post('/registration/checkSsn', request);
  }
  checkPhone(request: any): Observable<any> {
    return this.httpservice.post('/registration/checkPhone', request);
  }
  register(request: any): Observable<any> {
    return this.httpservice.post('/registration/register', request);
  }
  completeRegistration(request: any): Observable<any> {
    return this.httpservice.post('/registration/completeRegistration', request);
  }
   updatePhone(request: any): Observable<any>{
    return this.httpservice.post('/registration/updatePhone', request);
  }
  updateRecoveryEmail(request: any): Observable<any> {
    return this.httpservice.post('/registration/updateRecoveryEmail', request);
  }
  updateRecoveryEmailNotification(request: any): Observable<any> {
    return this.httpservice.post('/registration/updateRecoveryEmailNotification', request);
  }
  updatePhoneNumberNotification(request: any): Observable<any> {
    return this.httpservice.post('/registration/updatePhoneNumberNotification', request);
  }
  recoveryEmailVerification(request: any): Observable<any> {
    return this.httpservice.post('/registration/recoveryEmailVerification', request);
  }
  registrationSuccessEmail(request: any): Observable<any> {
    return this.httpservice.post('/registration/registrationSuccessEmail', request);
  }
  duplicateEmail(request: any): Observable<any> {
    return this.httpservice.post('/registration/duplicateEmail', request);
  }
  updateRegistrationStatus(request: any): Observable<any> {
    return this.httpservice.post('/registration/updateRegistrationStatus', request);
  }
  addRegisteredPerson(request: any): Observable<any> {
    return this.httpservice.post('/registration/addRegisteredPerson', request);
  }
  addExternalRegisterDetails(request: any, type='any'): Observable<any> {
    if(type==='fp'){
      return this.httpservice.post('/registration/addFPRegisterDetails', request);
    }
    if(type=== 'lea'){
    return this.httpservice.post('/registration/addLeaRegisterDetails', request);
    }
    if(type=== 'epp'){
    return this.httpservice.post('/registration/eppData', request);
  }
}
  

  
  smartyValidation(request: any): Observable<any> {
    return this.httpservice.post('/application-flow/smartyValidation', request);
  }
  leaRegister(request: any): Observable<any> {
    return this.httpservice.post('/registration/leaRegister', request);
  }
  fingerprintRegister(request: any): Observable<any> {
    return this.httpservice.post('/registration/fingerprintRegister', request);
  }
  updaterecoveryNewEmail(request: any): Observable<any> {
    return this.httpservice.post('/registration/updaterecoveryNewEmail', request);
  }
  updateNewPhone(request: any): Observable<any> {
    return this.httpservice.post('/registration/updateNewPhone', request);
  }
    addUser(request: any): Observable<any> {
    return this.httpservice.post('/registration/addUser', request);
  }
  changePassword(request: any): Observable<any> {
    return this.httpservice.post('/registration/change-password', request);
  }
  verifyRecoveryEmail(request: any): Observable<any> {
    return this.httpservice.post('/registration/verify-email-otp', request);
  }
  newRegistrationDate(request: any): Observable<any> {
    return this.httpservice.post('/registration/newRegistrationDate', request);
  }
  sendRecoveryEmailOtp(request: any): Observable<any> {
    return this.httpservice.post('/registration/send-email-otp', request);
  }

  sendPrimaryEmailOtp(request: any): Observable<any> {
    return this.httpservice.post('/registration/generate-primary-email-otp', request);
  }

  verifyPrimaryEmailOtp(request: any): Observable<any> {
    return this.httpservice.post('/registration/verify-primary-email-otp', request);
  }
  checkFpDpsIdDuplicate(dpsId: string): Observable<any> {
    return this.httpservice.get(`/registration/check-fp-dpsid-duplicate?dpsId=${dpsId}`);
  }

  checkFpPhoneDuplicate(phone: string): Observable<any> {
    return this.httpservice.get(`/registration/check-fp-phone-duplicate?phone=${phone}`);
  }

  checkLeaPhoneDuplicate(phone: string): Observable<any> {
    return this.httpservice.get(`/registration/check-lea-phone-duplicate?phone=${phone}`);
  }

getPrimaryEmailByPhone(request: { primaryPhone: string }): Observable<any> {
  return this.httpservice.post(`/registration/getPrimaryEmailByPhone`, request);
}

getUserDetailsByEmail(email: string): Observable<any> {
  return this.httpservice.get(`/registration/getExternalUserDetailsByEmail?email=${encodeURIComponent(email)}`);
}

getBusinessRuleByKey(category: string, strRuleKey: string): Observable<any> {
  return this.httpservice.get(`/business-rules/fetch-buisness-rules-by-key?category=${category}&strRuleKey=${strRuleKey}`);
}
checkPossibleDuplicate(request: any): Observable<any> {
  return this.httpservice.post('/registration/possibleDuplicateCheck', request);
}

 checkEppPhoneNumber(request: any): Observable<any> {
    return this.httpservice.post('/registration/checkEppPhoneNumber', request);
  }

  getUserAgreementContent(lookupcategoryid: number, key: string, value: string): Observable<any> {
    return this.httpservice.get(`/domain/lookup-by-category?lookupcategoryid=${lookupcategoryid}&key=${key}&value=${value}`);
  }

}